<template>
  <div class='cusLayer full' id='appDetail'>
    <AppModal
      v-show="modalToggle"
      :message="message"
      :btnCase="btnCase"
      @modalCancel="toggleModal"
      @modalCheck="modalCheck"
      @modalConfirm="modalConfirm"
    />
    <div class="addressDetailHeader">
      <img src="../../assets/img/ic_main_back.png" alt="" @click="closeBtn">
      <h2>상세정보입력</h2>
    </div>
    <div class="topContents">
      <h2 class="addressName" v-if="this.$i18n.locale == 'ko'">{{selectAddress.addressAlias ? selectAddress.addressAlias : selectAddress.jibunAddr}}</h2>
      <h2 class="addressName" v-else>{{selectAddress.jibunAddr}}</h2>
      <div class="roadNameBox">
        <span class="tag">도로명</span>
        <p class="roadName" v-if="this.$i18n.locale == 'ko'">{{selectAddress.roadAddrPart1 ? selectAddress.roadAddrPart1 : selectAddress.roadAddr}}</p>
        <p class="roadName" v-else>{{selectAddress.roadAddr}}</p>
      </div>
      <input type="text" class="addressDetailInput" v-model="detailInput" placeholder="상세 주소 입력"  :enterkeyhint="activeBtn != 2 ? 'done' : ''" @keyup.enter="hideKeyboard">
    </div>
    <div class="bottomContents" v-if="appFlag">
      <div class="aliasAddress">
        <div v-for="(btn, index) in btns" :key="index" :class="{ 'active' : activeBtn === index }" @click="changeActiveBtn(index)">
          <div class="addressDetailImg"></div>
          <span>{{ btn.name }}</span>
        </div>
      </div>
      <!-- <input type="text" class="addressAliasInput" v-model="aliasInput" placeholder="주소 별명 입력" v-if="activeBtn==2"> -->
      <input type="text" class="addressAliasInput" v-model="aliasInput" placeholder="주소 별명 입력" v-if="activeBtn==2" @focus="handleFocus" @blur="handleBlur" enterkeyhint="done" @keyup.enter="hideKeyboard">
    </div>
    <div class="bottomBtnWrap">
      <div class="addressDetailBottomBtn" @click="addressCheck()">완료</div>
    </div>
  </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
import { scrollSet } from '@/utils/Methods'
export default {
  props: {
    selectAddress: Object,
    updateType: Number,
    position: Object,
    addressLength: Number,
    recentAddress: Array
  },
  data () {
    return {
      // selectBtn: 0,
      // modalType: 0, // 0: 기본, 1: 주소중복
      btns: [
        { name: '우리집' },
        { name: '회사' },
        { name: '기타' }
      ],
      detailInput: '', // 상세주소
      aliasInput: '', // 주소별명
      activeBtn: '', // 0 우리집 1 회사 2 기타
      btnCase: 2,
      modalToggle: false,
      message: '',
      deleteAgree: false,
      addedDiv: null,
      handleCheck: false,
      heightSize: '400px'
    }
  },
  computed: {
    setAddressAlias () {
      switch (this.activeBtn) {
        case 0:
          return '우리집'
        case 1:
          return '회사'
        case 2:
          return this.aliasInput
        case undefined:
          return undefined
        default:
          return undefined
      }
    }
  },
  watch: {
    selectAddress () {
      this.detailInput = this.selectAddress.detailAddress
      this.aliasInput = this.selectAddress.addressAlias
      this.activeBtn = this.selectAddress.addressType
    }
  },
  methods: {
    changeActiveBtn (index) {
      if (this.activeBtn == index) {
        this.activeBtn = undefined
      } else {
        this.activeBtn = index
      }
    },
    handleFocus () {
      this.handleCheck = true
      this.addedDiv = scrollSet('#appDetail.cusLayer', '.bottomBtnWrap', this.addedDiv, this.handleCheck, this.heightSize)
    },
    handleBlur () {
      this.handleCheck = false
      this.addedDiv = scrollSet('#appDetail.cusLayer', '.bottomBtnWrap', this.addedDiv, this.handleCheck, this.heightSize)
    },
    updateAddress () {
      if (this.updateType === 1) {
        this.addressChange()
      } else if (this.updateType === 2) {
        this.addressSetting()
      }
    },
    toggleModal () {
      this.modalToggle = !this.modalToggle
    },
    // modalCancel () {
    // if (this.modalType == 1) {
    //   this.activeBtn = this.selectBtn
    // }
    // this.modalType = 0
    //   this.toggleModal()
    // },
    modalConfirm () {
      this.btnCase = 2
      this.toggleModal()
    },
    modalCheck () {
      this.updateAddress()
      this.toggleModal()
    },
    async addressCheck () {
      this.removeDim()
      if (!this.appFlag) { // 그룹QR일때 바로 appMain으로 이동
        this.selectAddress.x = this.position.x
        this.selectAddress.y = this.position.y
        this.selectAddress.detailAddress = this.detailInput

        const existsInRecent = this.recentAddress.some(address =>
          address.roadAddr === this.selectAddress.roadAddr &&
          address.detailAddress === this.selectAddress.detailAddress
        )

        if (!existsInRecent) {
          this.recentAddress.unshift(this.selectAddress)
        }
        localStorage.setItem('recentAddress', JSON.stringify(this.recentAddress))
        sessionStorage.setItem('selectAddress', JSON.stringify(this.selectAddress))
        this.$emit('moveGroup', this.selectAddress.emdNm)
        return
      }

      if (!this.aliasInput && this.activeBtn == 2) {
        this.btnCase = 1
        this.message = '기타 선택 시 별명은 필수 입력입니다.\n별명을 입력해주세요.'
        this.toggleModal()
        return
      }
      // this.selectBtn = this.activeBtn // 선택 버튼 저장

      const req = {
        appUserAddressId: this.selectAddress.appUserAddressId,
        addressType: this.activeBtn,
        addressAlias: this.setAddressAlias
      }
      const { data } = await service.addressCheck(req)
      if (data.resultCode !== 0) { // 0: api 정상
        return
      }
      if (this.addressLength === 10 && !this.deleteAgree && data.duplicateFlag !== 1 && this.updateType !== 1) { // 주소 10개이상
        this.message = '주소는 최대10개까지 저장 가능합니다. 가장 오래된 주소를 삭제 후 저장하시겠습니까?'
        this.toggleModal()
      } else if (data.duplicateFlag === 1) { // duplicateFlag 1: 주소중복
        // this.modalType = 1 // 모달취소버튼을 누르면 이전 activeBtn활성화
        if (this.activeBtn == 0) {
          this.message = '우리집으로 저장된 주소가 있습니다. 이주소로 변경하시겠습니까?'
          this.toggleModal()
        } else if (this.activeBtn == 1) {
          this.message = '회사으로 저장된 주소가 있습니다. 이주소로 변경하시겠습니까?'
          this.toggleModal()
        } else if (this.activeBtn == 2) {
          this.message = `${this.setAddressAlias}으로 저장된 주소가 있습니다. 이주소로 변경하시겠습니까?`
          this.toggleModal()
        }
      } else { // duplicateFlag 0: 신규주소
        this.deleteAgree = false
        this.updateAddress()
      }
    },
    async addressChange () {
      const req = {
        appUserAddressId: this.selectAddress.appUserAddressId,
        addressType: this.activeBtn,
        addressAlias: this.setAddressAlias,
        roadAddr: this.selectAddress.roadAddr,
        jibunAddr: this.selectAddress.jibunAddr,
        roadAddrPart1: this.selectAddress.roadAddrPart1,
        roadAddrPart2: this.selectAddress.roadAddrPart2,
        detailAddress: this.detailInput === undefined ? '' : this.detailInput,
        postCode: this.selectAddress.zipNo,
        district: this.selectAddress.emdNm,
        gpsX: this.selectAddress.gpsX,
        gpsY: this.selectAddress.gpsY
      }
      const { data } = await service.addressChange(req)
      if (data.resultCode === 0) {
        this.idRemovePopUp('#appDetail.cusLayer')
        this.aliasInput = ''
        this.detailInput = ''
        // this.activeBtn = null
        this.activeBtn = 0
        this.$emit('addresslist', this.selectAddress)
      }
    },
    async addressSetting () {
      const req = {
        townshipCode: this.selectAddress.admCd,
        addressType: this.activeBtn,
        addressAlias: this.setAddressAlias,
        roadAddr: this.selectAddress.roadAddr,
        jibunAddr: this.selectAddress.jibunAddr,
        roadAddrPart1: this.selectAddress.roadAddrPart1,
        roadAddrPart2: this.selectAddress.roadAddrPart2,
        detailAddress: this.detailInput ? this.detailInput : '',
        postCode: this.selectAddress.zipNo,
        district: this.selectAddress.emdNm,
        gpsX: this.position.x,
        gpsY: this.position.y
      }
      const { data } = await service.addressSetting(req)
      if (data.resultCode === 0) {
        this.idRemovePopUp('#appDetail.cusLayer')
        this.aliasInput = ''
        this.detailInput = ''
        this.activeBtn = null
        this.$emit('addresslist', this.selectAddress)
        this.$emit('onClickCloseBtn')
      }
    },
    closeBtn () {
      this.removeDim()
      this.idRemovePopUp('#appDetail.cusLayer')
    }
  }
}
</script>

<style scoped>
#appDetail{
  z-index: 10040;
}
</style>
